// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root
{
/* *******************************************************************
  DEFAULT VALUES
  ******************************************************************** */
  --default-language: fr;


  /* *******************************************************************
  DEBUG STYLES
  ******************************************************************** */
  --debug-border-width: 0px;
  --debug-border-app-width: 0px;
  --debug-border-style: solid;

 /* *******************************************************************
  COLORS THEME :
  ******************************************************************** */

  /* *******************************************************************
  APP PANELS STYLES
  ******************************************************************** */
  --panel-color-background-default: black;
  
  --panel-color-border: transparent;
  --panel-width-border: 1px;

/* *******************************************************************
  TAB STYLES
  ******************************************************************** */
  --tab-backcolor-content: #101010;
  --tab-backcolor-active-tab: #303030;
  --tab-backcolor-inactive-tab: #050505;
/* *******************************************************************
  TOOLSBAR
  ******************************************************************** */
  --toolsbar-backcolor: #red;
  --toolsbar-borderwidth: 1px;
  --toolsbar-bordercolor: #808080;
  --toolsbar-borderstyle: none;
  --toolsbar-backcolor: #101010;

  /* *******************************************************************
  DEFAULT COLORS
  --default-icon-color: #8b75a1;
  ******************************************************************** */
  --default-icon-color: #BED7EC;
  --default-disable-icon-color: #606060;

/* *******************************************************************
  PLAYER VIDEO
******************************************************************** */
  --player-buttons-height: 28px;

/* *******************************************************************
  DIALOG BASE
******************************************************************** */
--dialog-title-backcolor: #303030;
--dialog-content-backcolor: #101010;
--dialog-buttons-backcolor: #202020;


/* *******************************************************************
  LIST SUBTITLES
  ******************************************************************** */
--listsubtitles-backcolor: transparent;
--listsubtitles-card-subtitle-backcolor: #202020;


/* *******************************************************************
  TIME LINE
    ******************************************************************** */
  --timeline-backcolor: #303030;
  --timeline-bottom-height: 18px;
  --timeline-left-width: 150px;

  --timeline-tctrack-backcolor: #101010;
  --timeline-sttrack-backcolor: #181818;
  --timeline-emptytrack-backcolor: #151515;
  --timeline-waveformtrack-backcolor: #202020;
  --timeline-cptrack-backcolor: #181818;
  --timeline-transcripttrack-backcolor: #222222;

  --timeline-cursor-color: yellow;


  /* *******************************************************************
  SideBar Menu
  ******************************************************************** */
  --sidebar-color-text: white;
  --sidebar-color-disable-text: gray;
  --sidebar-color-selected-text: #ffffff;
  --sidebar-color-selectedbackground: #202020;



  /* *******************************************************************
  tooltip colors
  ******************************************************************** */
  --tooltip-background-color: #333;
  --tooltip-color: #fff;

  /* *******************************************************************
  simple Popup
  ******************************************************************** */
  --simplepopup-background-color: #404040;
  --simplepopup-icon-color: #FFFFFF;
  --simplepopup-titlebackground-color: #202020;
  --simplepopup-color: white;
  --simplepopup-button-border-color: white;
  --simplepopup-button-background-color: #202020;
  --simplepopup-button-background-over-color: #A0A0A0;
  --simplepopup-button-color: white;





}



.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
  filter: brightness(0) saturate(100%) invert(51%) sepia(15%) saturate(776%) hue-rotate(227deg) brightness(93%) contrast(87%);
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #162037;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.sr-only {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";;AAEA;;AAEA;;wEAEwE;EACtE,sBAAsB;;;EAGtB;;wEAEsE;EACtE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;;CAE5B;;wEAEuE;;EAEtE;;wEAEsE;EACtE,uCAAuC;;EAEvC,iCAAiC;EACjC,yBAAyB;;AAE3B;;wEAEwE;EACtE,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;AACvC;;wEAEwE;EACtE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;;EAE7B;;;wEAGsE;EACtE,6BAA6B;EAC7B,qCAAqC;;AAEvC;;sEAEsE;EACpE,6BAA6B;;AAE/B;;sEAEsE;AACtE,iCAAiC;AACjC,mCAAmC;AACnC,mCAAmC;;;AAGnC;;wEAEwE;AACxE,sCAAsC;AACtC,gDAAgD;;;AAGhD;;0EAE0E;EACxE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;;EAE5B,qCAAqC;EACrC,qCAAqC;EACrC,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;;EAE7C,+BAA+B;;;EAG/B;;wEAEsE;EACtE,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;;;;EAI3C;;wEAEsE;EACtE,gCAAgC;EAChC,qBAAqB;;EAErB;;wEAEsE;EACtE,uCAAuC;EACvC,iCAAiC;EACjC,4CAA4C;EAC5C,0BAA0B;EAC1B,wCAAwC;EACxC,8CAA8C;EAC9C,mDAAmD;EACnD,iCAAiC;;;;;;AAMnC;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,2HAA2H;AAC7H;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EAEzC,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;AAChC","sourcesContent":["\n\n:root\n{\n/* *******************************************************************\n  DEFAULT VALUES\n  ******************************************************************** */\n  --default-language: fr;\n\n\n  /* *******************************************************************\n  DEBUG STYLES\n  ******************************************************************** */\n  --debug-border-width: 0px;\n  --debug-border-app-width: 0px;\n  --debug-border-style: solid;\n\n /* *******************************************************************\n  COLORS THEME :\n  ******************************************************************** */\n\n  /* *******************************************************************\n  APP PANELS STYLES\n  ******************************************************************** */\n  --panel-color-background-default: black;\n  \n  --panel-color-border: transparent;\n  --panel-width-border: 1px;\n\n/* *******************************************************************\n  TAB STYLES\n  ******************************************************************** */\n  --tab-backcolor-content: #101010;\n  --tab-backcolor-active-tab: #303030;\n  --tab-backcolor-inactive-tab: #050505;\n/* *******************************************************************\n  TOOLSBAR\n  ******************************************************************** */\n  --toolsbar-backcolor: #red;\n  --toolsbar-borderwidth: 1px;\n  --toolsbar-bordercolor: #808080;\n  --toolsbar-borderstyle: none;\n  --toolsbar-backcolor: #101010;\n\n  /* *******************************************************************\n  DEFAULT COLORS\n  --default-icon-color: #8b75a1;\n  ******************************************************************** */\n  --default-icon-color: #BED7EC;\n  --default-disable-icon-color: #606060;\n\n/* *******************************************************************\n  PLAYER VIDEO\n******************************************************************** */\n  --player-buttons-height: 28px;\n\n/* *******************************************************************\n  DIALOG BASE\n******************************************************************** */\n--dialog-title-backcolor: #303030;\n--dialog-content-backcolor: #101010;\n--dialog-buttons-backcolor: #202020;\n\n\n/* *******************************************************************\n  LIST SUBTITLES\n  ******************************************************************** */\n--listsubtitles-backcolor: transparent;\n--listsubtitles-card-subtitle-backcolor: #202020;\n\n\n/* *******************************************************************\n  TIME LINE\n    ******************************************************************** */\n  --timeline-backcolor: #303030;\n  --timeline-bottom-height: 18px;\n  --timeline-left-width: 150px;\n\n  --timeline-tctrack-backcolor: #101010;\n  --timeline-sttrack-backcolor: #181818;\n  --timeline-emptytrack-backcolor: #151515;\n  --timeline-waveformtrack-backcolor: #202020;\n  --timeline-cptrack-backcolor: #181818;\n  --timeline-transcripttrack-backcolor: #222222;\n\n  --timeline-cursor-color: yellow;\n\n\n  /* *******************************************************************\n  SideBar Menu\n  ******************************************************************** */\n  --sidebar-color-text: white;\n  --sidebar-color-disable-text: gray;\n  --sidebar-color-selected-text: #ffffff;\n  --sidebar-color-selectedbackground: #202020;\n\n\n\n  /* *******************************************************************\n  tooltip colors\n  ******************************************************************** */\n  --tooltip-background-color: #333;\n  --tooltip-color: #fff;\n\n  /* *******************************************************************\n  simple Popup\n  ******************************************************************** */\n  --simplepopup-background-color: #404040;\n  --simplepopup-icon-color: #FFFFFF;\n  --simplepopup-titlebackground-color: #202020;\n  --simplepopup-color: white;\n  --simplepopup-button-border-color: white;\n  --simplepopup-button-background-color: #202020;\n  --simplepopup-button-background-over-color: #A0A0A0;\n  --simplepopup-button-color: white;\n\n\n\n\n\n}\n\n\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n  filter: brightness(0) saturate(100%) invert(51%) sepia(15%) saturate(776%) hue-rotate(227deg) brightness(93%) contrast(87%);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #162037;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.sr-only {\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  -webkit-clip-path: inset(50%) !important;\n  clip-path: inset(50%) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
